import React, { useMemo } from 'react';
import moment, { weekdays } from 'moment';
import lodash from 'lodash';
import { notification } from 'antd';
import { schedule_params, schedule_options } from '../components/schedule_changer';
import Axios from 'axios';


export const defaultDateFormat = "YYYY-MM-DD"

export const blobToFile=(theBlob, fileName)=>{       
    return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
}
export const copyStringToClipboard = function (str) {
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);

}

export const objectToFormData = function (obj, form, namespace) {

    var fd = form || new FormData();
    var formKey;

    for (var property in obj) {
        if (obj.hasOwnProperty(property)) {

            if (namespace) {
                formKey = namespace + '[' + property + ']';
            } else {
                formKey = property;
            }

            // if the property is an object, but not a File, use recursivity.
            if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {

                objectToFormData(obj[property], fd, property);

            } else {

                // if it's a string or a File object
                fd.append(formKey, obj[property]);
            }

        }
    }

    return fd;

};

export function toFormData(obj, form, namespace) {
    let fd = form || new FormData();
    let formKey;

    for (let property in obj) {
        if (obj.hasOwnProperty(property) && obj[property]) {
            if (namespace) {
                formKey = namespace + '[' + property + ']';
            } else {
                formKey = property;
            }

            // if the property is an object, but not a File, use recursivity.
            if (obj[property] instanceof Date) {
                fd.append(formKey, obj[property].toISOString());
            } else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                toFormData(obj[property], fd, formKey);
            } else { // if it's a string or a File object
                fd.append(formKey, obj[property]);
            }
        }
    }

    return fd;
}


export const objectbyString = function (o, s) {
    // let obj = JSON.parse(JSON.stringify(o));

    console.log("CALLED GETTER",o,s);
    try {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        // console.log("SEARCH FOR",a)
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                // console.log("DATA FOUND")
                o = o[k];
            } else {
                return;
            }
        }
    } catch (e) {
        // data not found
        console.log(`CALLED GETTER : DATA FOR ${s} not found`)
        return null;
    }
    return o;
}

export const objectAssignerByString = function (o, s, value, stringyfy = true) {
    // console.log(object)
    console.log("CALLED ASSIGNER ,",o,s,value)
    let obj = {};
    if (stringyfy) {
        obj = JSON.parse(JSON.stringify(o));
    } else {
        obj = o
    }
    try {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');

        // for next recursive assigner
        let list_keys = JSON.parse(JSON.stringify(a));
        list_keys.splice(0, 1)

        for (var i = 0, n = a.length; i < n; ++i) {
            var key = a[i];
            var next_key = a[i + 1];
            // console.log("NEXT KEY", next_key)
            if (!isNaN(next_key)) {
                // if next key is integer, then this obj is array type
                // console.log("ARRAY")
                if (Array.isArray(obj[key])) {
                    // Already array, push items

                } else {
                    // console.log("create new array")
                    obj[key] = []
                }
                let rem_data = (parseInt(next_key) - obj[key].length);

                for (i = 0; i <= (rem_data - 1); i++) {
                    obj[key].push({})
                    console.log("ASD")
                }


                obj[key] = objectAssignerByString(obj[key] || [], list_keys.join('.'), value, stringyfy)
                console.log("RECURRING", obj)
                return obj
            }
            else if (typeof next_key === 'string' && isNaN(next_key)) {
                // if next key is string, then is is object
                console.log("CREATE OBJ")
                if (!obj[key]) {
                    obj[key] = {}
                }
                obj[key] = objectAssignerByString(obj[key], list_keys.join('.'), value, stringyfy)
                return obj
            }
            else if (next_key == undefined) {
                // if no next key, this is the final value, so assign and return
                obj[key] = value;
                console.log("ASSIGN KEY",key,obj)
                return obj
            }
            else {
                console.log("CALLED ASSIGNER returning null")
                return;
            };
        }
    } catch (e) {
        console.log("CALLED ASSIGNER Cannot assign value", e)
    }
    console.log("CALLED ASSIGNER FINAL DATA",obj)
    return obj;
}

export const syntaxHighlightJSON = (json) => {


    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    let vals = [];

    json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,

        function (match) {
            var cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            vals.push(<span className={`${cls}`}> {match}</span>)
            // return '<span class="' + cls + '">' + match + '</span>';
        });

    return vals;
}

export const formatMoney = function (number, decimals, decimal_sep, thousands_sep) {
    var n = number || 0,
        c = isNaN(decimals) ? 2 : Math.abs(decimals), //if decimal is zero we must take it, it means user does not want to show any decimal
        d = decimal_sep || '.', //if no decimal separator is passed we use the dot as default decimal separator (we MUST use a decimal separator)
        t = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep, //if you don't want to use a thousands separator you can pass empty string as thousands_sep value

        sign = (n < 0) ? '-' : '',

        //extracting the absolute value of the integer part of the number and converting to string
        i = parseInt(n = Math.abs(n).toFixed(c)) + '',

        j = ((j = i.length) > 3) ? j % 3 : 0;
    return sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
}



export function schema_to_field(_schema=[]){
    let fields = [];

    if (Array.isArray(_schema)) {
        let schema_array = JSON.parse(JSON.stringify(_schema));
        schema_array.map((schemaObj) => {
            // Object.keys(schemaObj).map((key)=>{
            fields.push(getFieldObject(schemaObj, schemaObj.name))
            // })
        })
    } else {
        // not maintained order
        let schema_obj = JSON.parse(JSON.stringify(_schema));
        Object.keys(schema_obj).map((key) => {
            let schema_item = schema_obj[key];
            let schemaKey = key;
            fields.push(getFieldObject(schema_item, schemaKey))
        })
    }

    return fields;
}

function getFieldObject(schema_item, schemaKey) {

    let schema_validation=schema_item.validation||{};
    let field_object = {};
    let list_prop = {};
    let select_props = {};
    let json_props = {};
    let extra_props = {};
    let file_props={};
    // console.log("schema item is",schema_item)

    if(schema_validation.type=='file'){
        file_props={
            accept:schema_validation.file_type
        }
    }
    if (schema_validation.type === 'jsondata' && schema_validation.schema) {
        json_props = {
            type: 'form',
            schema: schema_to_field(schema_validation.schema)
        }
    }

    if (schema_validation.type === 'list') {
        if (schema_validation.list_type === 'jsondata') {
            list_prop = {
                type: 'json'
            }
        } else {
            list_prop = {
                'multiple': true,
                count: 1,
            }
        }
        if (schema_validation.list_type === 'jsondata' && schema_validation.schema) {
            list_prop = {
                type: 'form',
                multiple: true,
                count: 1,
                schema: schema_to_field(schema_validation.schema)
            }
        }
        if(schema_validation.list_type === 'jsondata'&&schema_item.name=='config'){
            console.log("config changing",schema_item)
            list_prop={
                type:'complexconfig',
                toggle_ui_json:true,
                multiple:true,
                count:1,
                isDraggable:true,
                toggle_main_json:true,
                main_json_size:600,
                extra_fields:schema_to_field(schema_item.required_params||[])
            }
        }

    }

    if (schema_validation.type === 'choice') {
        let list = schema_validation.choices || [];
        let options = [];
        list.map((item) => {
            options.push({
                text: item,
                value: item
            })
        })
        select_props = {
            options: options,
            filterable: true,
        }
    }
    if (schema_validation.type === 'select') {
        let list = schema_validation.options || [];
        let options = [];
        list.map((item) => {
            options.push({
                text: item.text,
                value: item.value
            })
        })
        select_props = {
            options: options,
            filterable: true,
        }
    }

    if (schema_validation.type === 'FK'||(schema_validation.type=='list'&&schema_validation.list_type=='FK')) {
        select_props = {
            type: 'networkselect',
            url: schema_validation.url || "/no-url",
            send_params: schema_validation.send_params,
            send_params_keys:schema_validation.send_params_keys

        }
    }
    if (schema_validation.conditional&&(
        schema_validation.type=='FK'||
        schema_validation.type=='boolean'||
        schema_validation.type=='select'||
        schema_validation.type=='choice'
    )) {
        let optional_schema = schema_validation.schema_options || {};
        extra_props = {
            additional: true,
            optional_schema: optional_schema,
            append_key: `${schemaKey}_values`
        }
    }

    field_object = {
        index: schemaKey,
        name: schema_item.display_name || schemaKey,
        help_text: schema_item.help_text,
        default: schema_validation && schema_validation.default,
        type: typeRepresentation(schema_validation.type),
        required:schema_validation.required,
        ...list_prop,
        ...select_props,
        ...json_props,
        ...extra_props,
        ...file_props
    }
    return field_object;

}

export function typeRepresentation(type) {
    switch (type) {
        case 'string':
        case 'email':
            return 'text';
        case 'integer':
        case 'decimal':
        case 'float':
        case 'double':
            return 'number';
        case 'list':
            return 'text';
        case 'jsondata':
            return 'json';
        case 'boolean':
            return 'bool';
        case 'choice':
        case 'select':
            return 'select';
        case 'password':
            return 'password';
        case 'datetime':
            return 'datetime'
        case 'date':
            return 'date'
        case  'file':
            return 'base64_file'
        default:
            return type;
    }

}

export function groupByDate({ list_data = [], dateKey = 'follow_up_date', dateFormat = 'YYYY-MM-DD', receiveFormat = 'YYYY-MM-DD' }) {
    let groupedData = lodash.groupBy(list_data, (item) => {
        return moment(item[dateKey], dateFormat).format(receiveFormat)
    })
    console.log(groupedData);
    return groupedData

}

export function showSuccessInNotification(success={},defaultMessage="Action Completed"){
    let result=success.result||{};
    if(typeof result.message==='string'){
        notification.success({
            message:result.message,
            duration:1
        })
    }else{
        notification.success({
            message:defaultMessage,
            duration:1

        })
    }
}
export function showErrorInNotification(error = {}) {
    console.log("erorr is",error)

    if (typeof error.error_message === 'string') {
        notification.error({
            message: error.error_message,

        });
    }
    else if (
        typeof error.validation_errors === 'string'
    ) {
        notification.error({
            message: "Validation Error",
            description: error.validation_errors
        })
    }
    else if (Array.isArray(error.validation_errors)) {
        notification.error({
            message: "Validation Error",
            description: error.validation_errors[0]
        })

    } else if (typeof error.validation_errors) {
        let error_messages = errorsFromObject(error.validation_errors)
        notification.error({
            message: "Validation Error",
            description: <div style={{
                display: 'flex',
                flexDirection: 'column',
                color: 'red'
            }}> {error_messages}</div>
        })
    }
}

function errorsFromObject(error_obj = {}) {
    let error_list = [];

    Object.keys(error_obj).map((key, index) => {
        let error_item = error_obj[key];
        if (typeof error_item === 'string') {
            error_list.push(
                <span>{error_item}</span>
            )
        }
        else if (Array.isArray(error_item)) {
            error_list.push(
                <span>{key} : {error_item[0]}</span>
            )
        } else if (typeof error_item === 'object') {
            error_list.push(...errorsFromObject(error_item))
        }
    });
    return error_list;
}



function stringToArray(string_list = "") {
    let array_list = [];
    array_list = string_list.split(",").filter(t => (t != "")).map((item) => parseInt(item)).sort((a, b) => (a - b));
    return array_list;
}

// export function getRangeFromSchedule(schedule={}){
//     let months = [], days = [], dayweeks = [], hours = [], minutes = [];
//     let _schedule_params = schedule_params;

//     let type = schedule.type;
//     let params = schedule.params || {};

//     let today = moment();

//     let currentObj = {
//         currentMonth: today.get('months') + 1,
//         currentDay: today.get('date'),
//         currentWeekDay: today.get('isoWeekdays') - 1,
//         currentHour: today.get('hours'),
//         currentMinute: today.get('minutes')
//     }

//     months =(params.month === "*"||params.month ==null) ? _schedule_params['month'].init_data : stringToArray(params.month);
//     days = (params.day === "*"||params.day ==null) ? _schedule_params['day'].init_data : stringToArray(params.day);
//     dayweeks =(params.day_of_week === "*"||params.day_of_week ==null) ? _schedule_params['day_of_week'].init_data : stringToArray(params.day_of_week);
//     hours = (params.hour === "*"||params.hour ==null) ? _schedule_params['hour'].init_data : stringToArray(params.hour);
//     minutes =(params.minute === "*"||params.minute ==null) ? _schedule_params['minute'].init_data : stringToArray(params.minute);

//     console.log("arrays",months,days,dayweeks,hours,minutes)

// }

// export const getSimilarStringUpto = React.useMemo(
//     () => _getSimilarStringUpto(string1, string2),
//     [string1, string2],
// );
export function _getSimilarStringUpto(string1,string2){
    console.log("matching types",typeof string1,string1,typeof string2,string2)
    if(typeof string1==='number'&&typeof string2==='number'){
        if(string1==string2){
            // both have same number
            return {
                value:`${string2}`,
                index:`${string2}`.length-1
            }
        }
    }
    if(typeof string1!='string'||typeof string2!='string'){
        return {
            value:"",
            index:0
        }
    }
    let str_array_1=string1.split("");
    let str_array_2=string2.split("");
    let matching_string=[];
    let highlight_upto_index=0;
    str_array_1.map((st1c,index_1)=>{
        if(st1c==str_array_2[index_1]){
            matching_string.push(st1c);
            highlight_upto_index=index_1
        }
    })
    return {
        value:matching_string.join(""),
        index:highlight_upto_index
    }
}



export function getRecentRange(schedule = {}) {
    let months = [], days = [], dayweeks = [], hours = [], minutes = [];
    let _schedule_params = schedule_params;

    let type = schedule.type;
    let params = schedule.params || {};

    months = params.month ? (params.month === "*") ? _schedule_params['month'].init_data : stringToArray(params.month) : [];
    days = params.day ? (params.day === "*") ? _schedule_params['day'].init_data : stringToArray(params.day) : [];
    dayweeks = params.day_of_week ? (params.day_of_week === "*") ? _schedule_params['day_of_week'].init_data : stringToArray(params.day_of_week) : [];
    hours = params.hour ? (params.hour === "*") ? _schedule_params['hour'].init_data : stringToArray(params.hour) : [];
    minutes = params.minute ? (params.minute === "*") ? _schedule_params['minute'].init_data : stringToArray(params.minute) : [];

    // For current Day
    console.log(moment().month(1).endOf('month').daysInMonth())

    let today = moment();
    let currentObj = {
        currentMonth: today.get('months') + 1,
        currentDay: today.get('date'),
        currentWeekDay: today.get('isoWeekdays') - 1,
        currentHour: today.get('hours'),
        currentMinute: today.get('minutes')
    }
    let nextMonth = getIndexValue(currentObj.currentMonth, months, 12);
    let nextDay = getIndexValue(currentObj.currentDay, days, 31);
    let nextDayWeek = getIndexValue(currentObj.currentWeekDay, dayweeks, 6);
    let nextHour = getIndexValue(currentObj.currentHour, hours, 23);
    let nextMinute = getIndexValue(currentObj.currentMinute, minutes, 59);

    let next_moment_obj = {};
    if (!type) {
        return {
            next: null
        }
    };

    switch (type) {
        case 'every_hour':
            console.log("every minute", minutes);
            if (nextMinute.found) {
                next_moment_obj['minute'] = nextMinute.nextValue
            } else {
                next_moment_obj['minute'] = nextMinute.nextValue
                next_moment_obj['hour'] = nextMinute.upgradeValue + currentObj.currentHour
            }
            break;
        case 'every_day':
            console.log("every day", days)
            if (nextHour.found) {
                console.log("found hr")
                if (nextHour.isSame) {
                    console.log("hour same")
                    if (nextMinute.found) {
                        next_moment_obj['minute'] = nextMinute.nextValue
                    } else {
                        next_moment_obj['minute'] = nextMinute.nextValue
                        next_moment_obj['day'] = nextMinute.upgradeValue + currentObj.currentDay
                    }
                } else {
                    next_moment_obj['hour'] = nextHour.nextValue;
                    next_moment_obj['minute'] = minutes[0]
                }
            } else {
                console.log("not found hr")
                next_moment_obj['minute'] = (minutes[0])
                next_moment_obj['hour'] = nextHour.nextValue;
                next_moment_obj['day'] = nextHour.upgradeValue + currentObj.currentDay;
            }
            console.log("current updated", next_moment_obj)

            break;
        case 'every_week':
            console.log("every week", dayweeks)
            if (nextDayWeek.found) {
                console.log("found day week")
                if (nextDayWeek.isSame) {
                    console.log("week same")

                    if (nextHour.found) {
                        console.log("found hr")

                        if (nextHour.isSame) {
                            console.log("hour same")

                            if (nextMinute.found) {
                                console.log("minute found")
                                next_moment_obj['minute'] = nextMinute.nextValue

                            } else {
                                console.log("minute not  found")
                                next_moment_obj['minute'] = nextMinute.nextValue
                                next_moment_obj['day_of_week'] = dayweeks[0] + 7
                            }

                        } else {
                            // clg not same
                            console.log("not same hour")
                            next_moment_obj['hour'] = nextHour.nextValue;
                            next_moment_obj['minute'] = minutes[0];
                            next_moment_obj['day_of_week'] = currentObj.currentWeekDay;
                        }
                    } else {
                        console.log("not found hr")
                        next_moment_obj['minute'] = (minutes[0])
                        next_moment_obj['hour'] = hours[0]
                        next_moment_obj['day_of_week'] = dayweeks[0] + 7
                    }

                } else {
                    console.log(("week nit same"))
                    next_moment_obj['minute'] = minutes[0]
                    next_moment_obj['hour'] = hours[0]
                    next_moment_obj['day_of_week'] = currentObj.currentWeekDay;

                }
            } else {
                console.log("not found day week")
                next_moment_obj['minute'] = minutes[0]
                next_moment_obj['hour'] = hours[0]
                next_moment_obj['day_of_week'] = nextDayWeek.nextValue + 7;
            }
            console.log("current updated", next_moment_obj)

            break;
        case 'every_month':
            console.log("every month", days)
            if (nextDay.found) {
                console.log("found day month")
                if (nextDay.isSame) {
                    console.log("day same")

                    if (nextHour.found) {
                        console.log("found hr")
                        if (nextHour.isSame) {
                            console.log("hour same")

                            if (nextMinute.found) {
                                console.log("minute found")
                                next_moment_obj['minute'] = nextMinute.nextValue
                            } else {
                                console.log("minute not  found")
                                next_moment_obj['minute'] = nextMinute.nextValue
                                next_moment_obj['hour'] = hours[0]
                                next_moment_obj['day'] = days[nextDay.index + 1] || days[0] //  days[0] + moment().endOf('month').daysInMonth()
                            }
                        } else {
                            // clg not same
                            console.log("not same hour")
                            next_moment_obj['hour'] = nextHour.nextValue;
                            next_moment_obj['minute'] = minutes[0];
                        }
                    } else {
                        console.log("not found hr")
                        next_moment_obj['minute'] = (minutes[0])
                        next_moment_obj['hour'] = hours[0]
                        next_moment_obj['day'] = days[nextDay.index + 1] || days[0]//days[0] + moment().endOf('month').daysInMonth()
                    }

                } else {
                    console.log(("day not same"))
                    next_moment_obj['minute'] = minutes[0]
                    next_moment_obj['hour'] = hours[0]
                    next_moment_obj['day'] = nextDay.nextValue;
                }
            } else {
                console.log("not found day month")
                next_moment_obj['minute'] = minutes[0]
                next_moment_obj['hour'] = hours[0]
                next_moment_obj['day'] = nextDay.nextValue + moment().endOf('month').daysInMonth();
                console.log("adding day", nextDay.nextValue + moment().endOf('month').daysInMonth())
            }
            console.log("current updated", next_moment_obj)
            break;

        case 'every_year':
            console.log("every year", months)
            if (nextMonth.found) {
                if (nextMonth.isSame) {
                    if (nextDay.found) {
                        console.log("found day month");
                        if (nextDay.isSame) {
                            console.log("day same")
                            if (nextHour.found) {
                                console.log("found hr")
                                if (nextHour.isSame) {
                                    console.log("hour same")
                                    if (nextMinute.found) {
                                        console.log("minute found")
                                        next_moment_obj['minute'] = nextMinute.nextValue
                                    } else {
                                        console.log("minute not  found")
                                        next_moment_obj['minute'] = nextMinute.nextValue
                                        next_moment_obj['hour'] = hours[0]
                                        next_moment_obj['day'] = days[0];
                                        next_moment_obj['month'] = months[0] + 12
                                    }
                                } else {
                                    console.log("not same hour")
                                    next_moment_obj['hour'] = nextHour.nextValue;
                                    next_moment_obj['minute'] = minutes[0];
                                }
                            } else {
                                console.log("not found hr")
                                next_moment_obj['minute'] = (minutes[0])
                                next_moment_obj['hour'] = hours[0];
                                next_moment_obj['day'] = days[0] + moment().endOf('month').daysInMonth()
                            }
                        } else {
                            console.log(("day not same"))
                            next_moment_obj['minute'] = minutes[0]
                            next_moment_obj['hour'] = hours[0]
                            next_moment_obj['day'] = nextDay.nextValue;
                        }
                    } else {
                        console.log("not found day month")
                        next_moment_obj['minute'] = minutes[0]
                        next_moment_obj['hour'] = hours[0]
                        next_moment_obj['day'] = days[0] + moment().endOf('month').daysInMonth();
                    }
                } else {
                    console.log("next month not same")
                    next_moment_obj['minute'] = minutes[0]
                    next_moment_obj['hour'] = hours[0]
                    next_moment_obj['day'] = days[0];
                    next_moment_obj['month'] = nextMonth.nextValue;
                }
            } else {
                console.log("not found month")
                next_moment_obj['minute'] = minutes[0];
                next_moment_obj['hour'] = hours[0];
                next_moment_obj['day'] = days[0];
                next_moment_obj['month'] = nextMonth.nextValue + 12;
            }
            console.log("current updated", next_moment_obj)
            break;
        default:
            break;
    }
    let next_moment = moment();
    if (next_moment_obj.minute != null) {
        next_moment.minute(next_moment_obj.minute)
    }
    if (next_moment_obj.hour != null) {
        next_moment.hours(next_moment_obj.hour)
    }
    if (next_moment_obj.day != null) {
        next_moment.date(next_moment_obj.day)
    }
    if (next_moment_obj.day_of_week != null) {
        next_moment.isoWeekday(next_moment_obj.day_of_week + 1)
    }
    if (next_moment_obj.month != null) {
        next_moment.months(next_moment_obj.month - 1)
    }
    console.log('current day', currentObj)
    console.log("NEXT RUN", next_moment.format('dddd MMMM YYYY-MM-DD hh:mmA'));
    // console.log("next r",moment().day(37).format('YYYY-MM-DD HH:mmA'))

    return {
        next: next_moment
    }
}


function getIndexValue(value, array_item, max_value) {
    let return_obj = {};
    let found = false;
    array_item.map((sch_value, index) => {
        console.log(sch_value, value)
        if (!found) {
            console.log("running for", sch_value)
            if ((sch_value) >= value) {
                console.log("FOUND index", sch_value, index)
                return_obj = {
                    index: index,
                    found: true,
                    nextValue: sch_value,
                    isSame: value === sch_value
                }
                found = true
            } else {
                return_obj = {
                    index: 0,
                    found: false,
                    nextValue: (array_item[0]),
                    isSame: false,
                    upgradeValue: 1
                }
            }
        }
    });
    return return_obj
}



// console.log({ A: ([2, 3, 4].join(',')) })


export const THEME_COLORS = {
    'error': '#f5222d',
    'success': '#52c41a',
    'warning': '#faad14',
    'pending': '#1890ff',
    null: '#d9d9d9',
}

export class NetworkDelaySearch {
    constructor(props) {

        let my_props = props || {};

        // console.log("network delay search", props)
        this.state = {
        }
        this.timeout = null
        this.onSearch = this.onSearch.bind(this);
        this.delay = my_props.delay || 400
    }

    onSearch = (callback) => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
            typeof callback === 'function' && callback()
        }, this.delay);
    }

}

export const overrideHeaderBack=(path)=>{
    try {
        window.header_assigner.overrideBack(path);
    } catch (e) { }
}

export const overrideHeaderTitle=(title)=>{
    try {
        window.header_assigner.assignTitle(title);
    } catch (e) { }
}



const isValidHex = (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)

const getChunksFromString = (st, chunkSize) => st.match(new RegExp(`.{${chunkSize}}`, "g"))

const convertHexUnitTo256 = (hexStr) => parseInt(hexStr.repeat(2 / hexStr.length), 16)

const getAlphafloat = (a, alpha) => {
    if (typeof a !== "undefined") {return a / 256}
    if (typeof alpha !== "undefined"){
        if (1 < alpha && alpha <= 100) { return alpha / 100}
        if (0 <= alpha && alpha <= 1) { return alpha }
    }
    return 1
}

export const getDownloadedFile = (_url,as_text=false) => {
    let promise = new Promise((resolve, reject) => {
      Axios({
        url: _url,
        method: 'GET',
        responseType:as_text?'text':'blob', // important
      }).then((response) => {
  
        resolve(response.data);
      })
        .catch(error => {
          reject(error)
        })
    })
    return promise;
  
  }

export const hexToRGBA = (hex, alpha) => {
    if (!isValidHex(hex)) {throw new Error("Invalid HEX")}
    const chunkSize = Math.floor((hex.length - 1) / 3)
    const hexArr = getChunksFromString(hex.slice(1), chunkSize)
    const [r, g, b, a] = hexArr.map(convertHexUnitTo256)
    return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`
}


String.prototype.insert = function(index, string) {
    if (index > 0)
    {
      return this.substring(0, index) + string + this.substring(index, this.length);
    }
  
    return string + this;
  };



let side_menu_hidden=localStorage.getItem("sliderCollapse")=='false'?false:true;

export const getSliderState=()=>{
    return side_menu_hidden;
}

export const setSliderState=(val)=>{
    localStorage.setItem("sliderCollapse",val)
    side_menu_hidden=val;
}

function create_UUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}
